(function() {
  /* start-dbtfy-addons */

  /* start-dbtfy-addtocart-animation */
  function themeAddtocartAnimation() {}
  /* end-dbtfy-addtocart-animation */

  /* start-dbtfy-age-check */
  function themeAgeCheck() {}

  function themeAgeCheckDestroy() {}
  /* end-dbtfy-age-check */

  /* start-dbtfy-agree-to-terms */
  function themeAgreeToTerms() {}

  function themeAgreeToTermsDestroy() {}
  /* end-dbtfy-agree-to-terms */

  /* start-dbtfy-automatic-geolocation */
  function themeAutomaticGeolocation() {}
  /* end-dbtfy-automatic-geolocation */

  /* start-dbtfy-back-in-stock */
  function themeBackInStock() {function BackInStock() {
      const dbtfy = document.querySelector(".dbtfy-back_in_stock");

      if (!dbtfy) {
        return;
      }

      const notifyForm = dbtfy.querySelector("form");
      const productOptions = document.querySelectorAll(".product-single__variants");
      const productJson = [];
      let isToShowSuccessForm = false;

      productOptions.length && productOptions.forEach((productOption) => {
        const section = productOption.closest("div[data-section-type='product-template']");
        const sectionId = section.getAttribute("data-section-id");
        const productId = +section.querySelector(".product-single").dataset.productId;
        const productMeta = section.querySelector(".product-single__meta--wrapper");

        setUnavailableVariantOnFormSuccess(section, productId);

        if ($(`#ProductJson-${sectionId}`).length) {
          productJson[sectionId] = JSON.parse(document.getElementById(`ProductJson-${sectionId}`).innerHTML);

          if (productMeta) {
            const config = {
              attributes: true,
              childList: false,
              subtree: false
            };

            const observer = new MutationObserver(() => {
              setFormVisibility(section, productJson);
            });

            observer.observe(productMeta, config);
          }

          document.body.addEventListener("change", function (e) {
            setFormVisibility(section, productJson, true);
          });

          setFormVisibility(section, productJson, true);
        }
      });

      sessionStorage.removeItem("notify_products");

      updateColorSwatchesLabels();

      notifyForm && notifyForm.addEventListener("submit", () => {
        const productSection = notifyForm.closest("div[data-section-type='product-template']");
        const productId = +productSection.querySelector(".product-single").dataset.productId;
        const variantSelect = productSection.querySelector("[id^='MainProductSelect']");
        const currentVariant = variantSelect.querySelector("option:checked");
        const variantId = currentVariant ? +currentVariant.value : null;
        const savedNotifyProducts = sessionStorage.getItem("notify_products");
        let notifyProducts = [];

        if (savedNotifyProducts) {
          notifyProducts = JSON.parse(savedNotifyProducts);
        }

        notifyProducts = notifyProducts.filter((product) => {
          return product.id !== productId;
        });

        notifyProducts.push({
          id: productId,
          variantId: variantId
        });

        sessionStorage.setItem("notify_products", JSON.stringify(notifyProducts));
      });

      function updateColorSwatchesLabels() {
        const colorSwatches = document.querySelectorAll(".input-color_swatches:checked");

        colorSwatches.forEach((colorSwatch) => {
          const swatchElementsWrapper = colorSwatch.closest(".custom_swatch_elements");
          const colorOptionLabel = swatchElementsWrapper ? swatchElementsWrapper.querySelector(".label-color_swatches") : null;
          const colorOptionLabelValue = colorOptionLabel ? colorOptionLabel.getAttribute("data-label") : null;
          const optionValue = colorSwatch.value;

          if (colorOptionLabel && colorOptionLabelValue) {
            colorOptionLabel.innerHTML = `${colorOptionLabelValue}: <span class="variant-label-option-value">${optionValue}</span>`;
          }
        });
      }

      function setUnavailableVariantOnFormSuccess(section, productId) {
        const savedNotifyProducts = sessionStorage.getItem("notify_products");
        const notifyProducts = savedNotifyProducts ? JSON.parse(savedNotifyProducts) : [];
        const notifyProduct = notifyProducts.find((notifyProduct) => {
          return notifyProduct.id === productId;
        });

        if (!notifyProduct) {
          return;
        }

        const productSelectorType = section.dataset.productSelector;
        const variant = section.querySelector(`[id^='MainProductSelect'] option[value='${notifyProduct.variantId}']`);

        if (!variant) {
          return;
        }

        const options = [variant.getAttribute("data-option-1"), variant.getAttribute("data-option-2"), variant.getAttribute("data-option-3")];

        switch (productSelectorType) {
          case "radio":
            options.forEach((option, index) => {
              const optionElements = section.querySelectorAll(`.single-option-selector__radio[name='option${index + 1}'][value='${CSS.escape(option)}'], .input-color_swatches[data-option-position='option${index + 1}'][value='${CSS.escape(option)}']`);

              optionElements.forEach((optionElement) => {
                optionElement.checked = true;
                optionElement.dispatchEvent(new Event("change"));
              });
            });

            break;

          case "select":
            options.forEach((option, index) => {
              const optionElements = section.querySelectorAll(".single-option-selector__radio");

              if (!optionElements.length) {
                return;
              }

              const select = optionElements[index];

              if (!select) {
                return;
              }

              const isAvailableOption = select.querySelector(`option[value='${CSS.escape(option)}']`);

              if (isAvailableOption) {
                select.value = option;
                select.dispatchEvent(new Event("change"));
              }
            });

            break;
        }

        const notifyFormSuccess = section.querySelector(".notify_form__success");
        const notifyFormLabel = section.querySelector(".notify_form__label");
        const notifyFormInputs = section.querySelector(".notify_form__inputs");

        notifyFormSuccess.removeAttribute("hidden");
        notifyFormLabel.setAttribute("hidden", "hidden");
        notifyFormInputs.setAttribute("hidden", "hidden");

        isToShowSuccessForm = true;
      }

      function setFormVisibility(section, productJson, isChangeEvent) {
        if (isToShowSuccessForm) {
          isToShowSuccessForm = false;

          return;
        }

        const sectionId = section.getAttribute("data-section-id");
        const productMeta = section.querySelector(".product-single__meta--wrapper");
        const formLabel = section.querySelector(".notify_form__label");
        const formMessage = section.querySelector(".notify_form_message");
        const atcButton = section.querySelector(".product-single__add-to-cart");
        const productSelect = section.querySelector("[id^='MainProductSelect']");
        const formInputs = section.querySelector(".notify_form__inputs");
        const formSuccess = section.querySelector(".notify_form__success");
        const selectedVariantId = +productSelect.value;
        const variants = productJson[sectionId] ? productJson[sectionId].variants : [];
        const isVariantSoldOut = productMeta ? productMeta.classList.contains("variant-soldout") : false;
        let selectedVariant = null;
        let isVariantAvailable = false;

        $.each(variants, function(index, value) {
          if (selectedVariantId === this.id) {
            selectedVariant = this;
            isVariantAvailable = this.available;
          }
        });

        if (formSuccess && isChangeEvent) {
          formSuccess.setAttribute("hidden", "hidden");
        }

        if (!isVariantAvailable || isVariantSoldOut) {
          const productUrl = formInputs.dataset.url;
          const formBodyMessage = formInputs.dataset.bodyMessage;

          formInputs.removeAttribute("hidden");
          formLabel.removeAttribute("hidden");
          formMessage.setAttribute("data-body", `${formBodyMessage}${productUrl}?variant=${selectedVariantId}`);
          formMessage.setAttribute("value", `${formBodyMessage}${productUrl}?variant=${selectedVariantId}`);

          if (atcButton) {
            atcButton.setAttribute("hidden", "hidden");
          }
        } else {
          formInputs.setAttribute("hidden", "hidden");
          formLabel.setAttribute("hidden", "hidden");

          if (atcButton) {
            atcButton.removeAttribute("hidden");
          }
        }
      }
    }

    BackInStock();}

  function themeBackInStockDestroy() {destroyBackInStock();

    function destroyBackInStock() {
      const backInStocks = document.querySelectorAll(".dbtfy-back_in_stock");

      backInStocks.length && backInStocks.forEach((backInStock) => {
        backInStock.remove();
      });
    }}
  /* end-dbtfy-back-in-stock */

  /* start-dbtfy-cart-countdown */
  function themeCartCountdown() {}

  function themeCartCountdownDestroy() {}
  /* end-dbtfy-cart-countdown */

  /* start-dbtfy-cart-discount */
  function themeCartDiscount() {}

  function themeCartDiscountDestroy() {}
  /* end-dbtfy-cart-discount */

  /* start-dbtfy-cart-favicon */
  function themeCartFavicon() {}
  /* end-dbtfy-cart-favicon */

  /* start-dbtfy-cart-goal */
  function themeCartGoal() {}

  function themeCartGoalDestroy() {}
  /* end-dbtfy-cart-goal */

  /* start-dbtfy-cart-savings */
  function themeCartSavings() {}

  function themeCartSavingsDestroy() {}
  /* end-dbtfy-cart-savings */

  /* start-dbtfy-cart-upsell */
  function themeCartUpsell() {}

  function themeCartUpsellDestroy() {}
  /* end-dbtfy-cart-upsell */

  /* start-dbtfy-collection-addtocart */
  function themeCollectionAddtocart() {}

  function themeCollectionAddtocartDestroy() {}
  /* end-dbtfy-collection-addtocart */

  /* start-dbtfy-collection-filters */
  function themeCollectionFilters() {function CollectionFilters() {
      const collectionSection = document.querySelector(".collection-section");
      const clearAllButton = document.querySelector(".filter-clear-all");
      const drawerFooter = document.querySelector("#dbtfyCollectionFilter .drawer__footer");

      window.addEventListener("popstate", (event) => {
        history.scrollRestoration = "manual";
        filterParams();
        filterAjaxClick();
      });

      filterParams();
      showClearButtons();
      clearCategorySelectedVariants();
      clearAllSelectedVariant();
      ajaxDefaultPagination();
      choiceOfOptions();
      addFilterCategory();

      function choiceOfOptions() {
        const listFilterVariants = document.querySelectorAll(".filter-card-item label");

        listFilterVariants.forEach((filterVariant) => {
          filterVariant.addEventListener("click", (event) => {
            const parentWrapper = filterVariant.closest(".checkbox");

            if (parentWrapper.classList.contains("disabled")) {
              return;
            }

            const currentTag = filterVariant.previousElementSibling.value;
            let filterTags = [];

            if (Shopify.queryParams.constraint) {
              filterTags = Shopify.queryParams.constraint.split('+');
            }

            if (currentTag) {
              const tagPositionInArray = filterTags.indexOf(currentTag);

              if (tagPositionInArray >= 0) {
                filterTags.splice(tagPositionInArray, 1);
              } else {
                filterTags.push(currentTag);
              }
            }

            if (filterTags.length) {
              Shopify.queryParams.constraint = filterTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }

            filterAjaxClick();
          });
        });
      }

      function filterParams() {
        Shopify.queryParams = {};

        if (location.search.length) {
          const aCouples = location.search.substr(1).split('&');
          let aKeyValue = "";

          for (i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');

            if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      }

      function filterAjaxClick(baseLink) {
        delete Shopify.queryParams.page;
        const newUrl = createUrl(baseLink);

        history.pushState({
          param: Shopify.queryParams
        }, newUrl, newUrl);

        getProducts(newUrl);
      }

      function createUrl(baseLink) {
        const pageUrlParams = new URLSearchParams(Object.entries(Shopify.queryParams)).toString().replace(/%2B/g, '+');

        if (baseLink) {
          if (pageUrlParams !== "") {
            return baseLink + "?" + pageUrlParams;
          } else {
            return baseLink;
          }
        }

        if (pageUrlParams) {
          return location.pathname + "?" + pageUrlParams;
        } else {
          return location.pathname;
        }
      }

      function getProducts(url) {
        fetch(url)
          .then(function (response) {
            return response.text()
          })
          .then(function (html) {
            let newPage = new DOMParser();
            let newPageHTML = newPage.parseFromString(html, "text/html");

            updateSidebar(newPageHTML);
            updateListProducts(newPageHTML);
            updatePagination(newPageHTML);
            updateCollectionInformation(newPageHTML);
          });
      }

      function updateListProducts(page) {
        const newList = page.querySelector(".collection-list-products");
        const currentList = document.querySelector(".collection-list-products");

        currentList.innerHTML = newList.innerHTML;

        themeQuickView();
      }

      function updateSidebar(page) {
        const oldCollectionTemplateContainer = document.querySelector("#dbtfyCollectionFilter");
        const oldFilterListGroupWrapper = oldCollectionTemplateContainer.querySelector(".drawer-left__inner");
        const newCollectionTemplateContainer = page.querySelector("#dbtfyCollectionFilter");
        const newFilterListGroupWrapper = newCollectionTemplateContainer.querySelector(".drawer-left__inner");

        oldFilterListGroupWrapper.innerHTML = newFilterListGroupWrapper.innerHTML;

        showClearButtons();
        choiceOfOptions();
        clearCategorySelectedVariants();
        addFilterCategory();
      }

      function updateCollectionInformation(page) {
        const currentCollectionHeroContainer = document.querySelector(".hero-container");
        const currentCollectionHeaderContainer = document.querySelector(".simple_collection_header");
        const newCollectionHeroContainer = page.querySelector(".hero-container");
        const newCollectionHeroContainerStyles = page.querySelector(".hero-header-style");
        const newCollectionHeaderContainer = page.querySelector(".simple_collection_header");
        const mainContentContainer = document.querySelector("#mainContent");

        document.title = page.title;

        if (currentCollectionHeroContainer) {
          document.querySelector(".hero-header-style").remove();
          currentCollectionHeroContainer.remove();
        } else {
          currentCollectionHeaderContainer.remove();
        }

        if (newCollectionHeroContainer) {
          mainContentContainer.insertAdjacentElement("afterbegin", newCollectionHeroContainer);
          mainContentContainer.insertAdjacentElement("afterbegin", newCollectionHeroContainerStyles);
        } else {
          document.querySelector(".collection-controls").insertAdjacentHTML("beforebegin", newCollectionHeaderContainer.outerHTML);
        }
      }

      function updatePagination(page) {
        const currentList = document.querySelector(".collection-list-products");
        const paginationClass = (currentList.getAttribute('id') !== null) ? ".dbtfy-infinite_scroll" : ".pagination";
        const newInfiniteScrollPagination = page.querySelector(paginationClass);
        const oldInfiniteScrollPagination = document.querySelector(paginationClass);

        if (oldInfiniteScrollPagination) {
          oldInfiniteScrollPagination.remove();
        }

        if (newInfiniteScrollPagination) {
          currentList.insertAdjacentElement("afterend", newInfiniteScrollPagination);
        }

        if (currentList.getAttribute('id') !== null) {
          themeInfiniteScroll();
        } else {
          ajaxDefaultPagination();
        }
      }

      function addFilterCategory() {
        const filterCategories = document.querySelectorAll(".dbtfy-filter-list-links a");

        filterCategories.forEach((category) => {
          category.addEventListener("click", (event) => {
            event.preventDefault();

            let parentEl = category.closest("li");
            let activeEl = document.querySelector(".dbtfy-filter-list-links li.active");

            if (!parentEl.classList.contains("active")) {
              let categoryLink = category.href;

              delete Shopify.queryParams.q;
              filterAjaxClick(categoryLink);

              if (activeEl) {
                activeEl.classList.remove("active");
              }

              parentEl.classList.add("active");
            }
          });
        });
      }

      function showClearButtons() {
        const listFilterGroups = document.querySelectorAll(".dbtfy-filter-tags-group");
        let countOfActiveSections = 0;

        listFilterGroups.forEach((group) => {
          let groupInputs = group.querySelectorAll("input");
          let groupInputsArray = Array.from(groupInputs).filter((input) => input.checked === true);
          let clearButton = group.querySelector(".filter-clear");

          if (groupInputsArray.length > 0) {
            clearButton.hidden = false;
            countOfActiveSections++;
          } else {
            clearButton.hidden = true;
          }
        });

        if (countOfActiveSections) {
          if (clearAllButton) {
            clearAllButton.hidden = false;
          }

          if (drawerFooter) {
            drawerFooter.hidden = false;
          }
        } else {
          if (clearAllButton) {
            clearAllButton.hidden = true;
          }

          if (drawerFooter) {
            drawerFooter.hidden = true;
          }
        }
      }

      function clearAllSelectedVariant() {
        const listClearButtons = document.querySelectorAll(".filter-clear");

        clearAllButton && clearAllButton.addEventListener("click", (event) => {
          listClearButtons.forEach((button) => {
            button.hidden = true;
          });

          delete Shopify.queryParams.constraint;

          filterAjaxClick();
        });
      }

      function clearCategorySelectedVariants() {
        const listClearButtons = document.querySelectorAll(".filter-clear");

        listClearButtons.forEach((button) => {
          button.addEventListener("click", (event) => {
            event.preventDefault();

            let filterTags = [];
            let parrentGroup = button.closest(".dbtfy-filter-tags-group");
            let parrentGroupInputs = parrentGroup.querySelectorAll("input");
            let parrentGroupInputsArrray = Array.from(parrentGroupInputs).filter((input) => input.checked === true);

            if (Shopify.queryParams.constraint) {
              filterTags = Shopify.queryParams.constraint.split('+');
            }

            parrentGroupInputsArrray.forEach((inputElement) => {
              let tagName = inputElement.value;

              inputElement.checked = false;

              if (tagName) {
                let tagPositionInArray = filterTags.indexOf(tagName);

                if (tagPositionInArray >= 0) {
                  filterTags.splice(tagPositionInArray, 1);
                }
              }
            });

            if (filterTags.length) {
              Shopify.queryParams.constraint = filterTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }

            filterAjaxClick();
          });
        });
      }

      function ajaxDefaultPagination() {
        const paginationContainer = document.querySelector(".pagination");

        if (!paginationContainer) {
          return;
        }

        const listPages = paginationContainer.querySelectorAll(".page a");

        listPages.forEach((page) => {
          page.addEventListener("click", (event) => {
            const pageLink = page.getAttribute("href").match(/page=\d+/g);

            if (pageLink) {
              Shopify.queryParams.page = parseInt(pageLink[0].match(/\d+/g));

              if (Shopify.queryParams.page) {
                const newUrl = createUrl();

                history.pushState({
                  param: Shopify.queryParams
                }, newUrl, newUrl);

                getProducts(newUrl);

                collectionSection.scrollIntoView({block: "start", behavior: "smooth"});
              }
            }

            event.preventDefault();
          });
        })
      }
    }

    document.addEventListener("shopify:section:select", (event) => {
      if (event.detail.sectionId === "dbtfy-collection-filters") {
        timber.FilterDrawer.open(event);
      }
    });

    document.addEventListener("shopify:section:deselect", (event) => {
      if (event.detail.sectionId === "dbtfy-collection-filters") {
        timber.FilterDrawer.close(event);
      }
    });

    CollectionFilters();}

  function themeCollectionFiltersDestroy() {document.body.classList.add("dbtfy-collection-filters-destroy");

      function CollectionFiltersDestroy() {
        const filterSection = document.querySelector("#shopify-section-dbtfy-collection-filters");
        const filterButton = document.querySelector(".collection-filters-btn");
        const filterButtonContainer = filterButton ? filterButton.closest("div") : null;

        if (filterSection) {
          filterSection.remove();
        }

        if (filterButtonContainer) {
          filterButtonContainer.remove();
        }
      }

      CollectionFiltersDestroy();}
  /* end-dbtfy-collection-filters */

  /* start-dbtfy-color-swatches */
  function themeColorSwatches() {function ColorSwatches() {
      const translations = theme.strings;
      const colorSwatches = document.querySelectorAll(".input-color_swatches");

      colorSwatches.forEach((colorSwatch) => {
        if (colorSwatch.hasAttribute("data-has-change-event")) {
          return;
        }

        colorSwatch.addEventListener("change", () => {
          const swatchElementsWrapper = colorSwatch.closest(".custom_swatch_elements");
          const colorOptionLabel = swatchElementsWrapper ? swatchElementsWrapper.querySelector(".label-color_swatches") : null;
          const colorOptionLabelValue = colorOptionLabel ? colorOptionLabel.getAttribute("data-label") : null;

          const sectionId = colorSwatch.dataset.sectionId;
          const optionForm = document.getElementById(`AddToCartForm--${sectionId}`);

          if (!optionForm) {
            return;
          }

          const optionIndex = colorSwatch.dataset.index;
          const optionValue = colorSwatch.value;

          if (colorOptionLabel && colorOptionLabelValue) {
            colorOptionLabel.innerHTML = `${colorOptionLabelValue}: <span class="variant-label-option-value">${optionValue}</span>`;
          }

          const option = optionForm.querySelector(`.single-option-selector__radio[data-index="option${optionIndex}"][value="${CSS.escape(optionValue)}"]`);

          if (option) {
            option.checked = true;
            option.dispatchEvent(new Event("change"));

            return;
          }

          const select = optionForm.querySelector(`select.single-option-selector__radio[data-index="option${optionIndex}"]`);

          if (select) {
            select.value = optionValue;
            select.dispatchEvent(new Event("change"));
          }
        });

        colorSwatch.setAttribute("data-has-change-event", "true");
      });

      const colorSwatchesGrid = document.querySelectorAll(".input-color_swatches--product-grid");

      colorSwatchesGrid.forEach((swatch) => {
        swatch.addEventListener("change", () => {
          const colorName = swatch.getAttribute("value");
          const productId = swatch.dataset.productId;
          const productSelect = document.getElementById(`ProductSelect-${productId}`);
          const availableVariants = productSelect.querySelectorAll("option");
          const targetVariant = Array.from(availableVariants).find((variant) => {
            const option1 = variant.dataset.option1;
            const option2 = variant.dataset.option2;
            const option3 = variant.dataset.option3;

            return option1 === colorName || option2 === colorName || option3 === colorName;
          });

          if (!targetVariant) {
            return;
          }

          const targetVariantId = targetVariant.getAttribute("value");
          const targetVariantImageSrc = targetVariant.dataset.image;
          const targetVariantRegularPrice = targetVariant.dataset.price;
          const targetVariantCompareAtPrice = targetVariant.dataset.compareAtPrice;

          const allSameProductSwatches = document.querySelectorAll(`.input-color_swatches--product-grid[data-product-id="${productId}"][value="${colorName}"]`);

          allSameProductSwatches.forEach((productSwatch) => {
            const productGridItem = productSwatch.closest(".grid-product");
            const productImage = productGridItem ? productGridItem.querySelector(".product--image") : null;
            const productHoverImage = productGridItem ? productGridItem.querySelector(".product-hover-image img") : null;
            const productLinks = productGridItem ? productGridItem.querySelectorAll(".grid-product__image-link, .grid-product__meta") : null;
            const productPriceWrapper = productGridItem ? productGridItem.querySelector(".grid-product__price-wrap") : null;
            const productRegularPrice = productPriceWrapper ? productPriceWrapper.querySelector(".price-regular") : null;
            const productComparePrice = productPriceWrapper ? productPriceWrapper.querySelector(".price-compare") : null;

            if (productGridItem) {
              productGridItem.classList.add("cs-active");
            }

            // Change product image
            if (productImage && targetVariantImageSrc) {
              productImage.removeAttribute("srcset");
              productImage.src = targetVariantImageSrc;

              if (productHoverImage) {
                productHoverImage.src = targetVariantImageSrc;
                productHoverImage.removeAttribute("srcset");
              }
            }

            // Change product link
            if (productLinks && productLinks.length) {
              productLinks.forEach((productLink) => {
                const link = productLink.href;

                productLink.href = `${link.split("?variant=")[0]}?variant=${targetVariantId}`;
              });
            }

            // Change product price
            if (productRegularPrice || productComparePrice) {
              if (productRegularPrice) {
                productRegularPrice.innerHTML = `<span class="money">${theme.Currency.formatMoney(+targetVariantRegularPrice, theme.strings.moneyFormat)}</span>`;

                if (targetVariantCompareAtPrice && productComparePrice) {
                  productRegularPrice.classList.add("on-sale", "text-sale");
                  productRegularPrice.setAttribute("aria-label", translations.salePrice);
                } else {
                  productRegularPrice.classList.remove("on-sale", "text-sale");
                  productRegularPrice.setAttribute("aria-label", translations.regularPrice);
                }
              }

              if (targetVariantCompareAtPrice && productComparePrice) {
                productComparePrice.classList.remove("hide");
                productComparePrice.innerHTML = `<span class="money">${theme.Currency.formatMoney(+targetVariantCompareAtPrice, theme.strings.moneyFormat)}</span>`;
              } else {
                productComparePrice.classList.add("hide");
                productComparePrice.innerHTML = " ";
              }
            }

            // Convert the product price on select change based on selected currency
            var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']"),
              shopCurrency = theme.strings.shopCurrency;

            if (currencySelector.length && shopCurrency && Currency.currentCurrency) {
              Currency.convertAll(shopCurrency, Currency.currentCurrency);
            }
          });
        });
      });
    }

    ColorSwatches();

    $(document).on("shopify:section:load", function () {
      ColorSwatches();
    });

    $("body").on("afterRecommendationLoad", function () {
      ColorSwatches();
    });}

  function themeColorSwatchesDestroy() {document.body.classList.add("dbtfy-color_swatches-destroy");

    destroyColorSwatches();

    $(document).on("shopify:section:load", function () {
      destroyColorSwatches();
    });

    $("body").on("afterRecommendationLoad", function(evt) {
      destroyColorSwatches();
    });

    function destroyColorSwatches() {
      const colorSwatches = document.querySelectorAll(".dbtfy-color_swatches");
      const optionSelectors = document.querySelectorAll(".product-form__item");

      colorSwatches.length && colorSwatches.forEach((colorSwatch) => {
        colorSwatch.remove();
      });

      optionSelectors.length && optionSelectors.forEach((optionSelector) => {
        optionSelector.removeAttribute("hidden");
      });
    }}
  /* end-dbtfy-color-swatches */

  /* start-dbtfy-cookie-box */
  function themeCookieBox() {}

  function themeCookieBoxDestroy() {}
  /* end-dbtfy-cookie-box */

  /* start-dbtfy-custom-currencies */
  function themeCustomCurrencies() {}

  function themeCustomCurrenciesDestroy() {}
  /* end-dbtfy-custom-currencies */

  /* start-dbtfy-delivery-time */
  function themeDeliveryTimeDestroy() {}
  /* end-dbtfy-delivery-time */

  /* start-dbtfy-discount-saved */
  function themeDiscountSaved() {}

  function themeDiscountSavedDestroy() {}
  /* end-dbtfy-discount-saved */

  /* start-dbtfy-facebook-messenger */
  function themeFacebookMessengerDestroy() {}
  /* end-dbtfy-facebook-messenger */

  /* start-dbtfy-faq-page */
  function themeFaqPage() {}

  function themeFaqPageDestroy() {}
  /* end-dbtfy-faq-page */

  /* start-dbtfy-inactive-tab-message */
  function themeInactiveTabMessage() {}
  /* end-dbtfy-inactive-tab-message */

  /* start-dbtfy-infinite-scroll */
  function themeInfiniteScroll() {function InfiniteScroll() {
      const dbtfy = document.querySelector(".dbtfy-infinite_scroll");

      if (!dbtfy) {
        return;
      }

      function callBack() {
        document.body.dispatchEvent(new CustomEvent("afterRecommendationLoad"));
      }

      const endlessType = dbtfy.dataset.endlessType;

      new Ajaxinate({
        container: "#infiniteScrollContainer",
        pagination: "#infiniteScrollPagination",
        method: endlessType,
        callback: callBack
      });

      // Hide default pagination
      const paginationBlocks = document.querySelectorAll(".pagination");

      paginationBlocks.forEach((pagination) => {
        pagination.setAttribute("hidden", "hidden");
      });
    }

    InfiniteScroll();}

  function themeInfiniteScrollDestroy() {destroyInfiniteScroll();

    function destroyInfiniteScroll() {
      document.body.classList.add("dbtfy-infinite_scroll-destroy");

      const infiniteScroll = document.querySelector(".dbtfy-infinite_scroll");

      if (!infiniteScroll) {
        return;
      }

      infiniteScroll.remove();

      if (typeof Ajaxinate === "undefined") {
        return;
      }

      const endlessInfiniteScroll = new Ajaxinate();

      endlessInfiniteScroll.destroy();
    }}
  /* end-dbtfy-infinite-scroll */

  /* start-dbtfy-instagram-feed */
  function themeInstagramFeed() {}

  function themeInstagramFeedDestroy() {}
  /* end-dbtfy-instagram-feed */

  /* start-dbtfy-inventory-quantity */
  function themeInventoryQuantity() {}

  function themeInventoryQuantityDestroy() {}
  /* end-dbtfy-inventory-quantity */

  /* start-dbtfy-linked-options */
  function themeLinkedOptions() {}
  /* end-dbtfy-linked-options */

  /* start-dbtfy-live-view */
  function themeLiveView() {}

  function themeLiveViewDestroy() {}
  /* end-dbtfy-live-view */

  /* start-dbtfy-mega-menu */
  function themeMegaMenu() {}

  function themeMegaMenuDestroy() {}
  /* end-dbtfy-mega-menu */

  /* start-dbtfy-menu-bar */
  function themeMenuBarDestroy() {destroyMenuBars();

    function destroyMenuBars() {
      const menus = document.querySelectorAll(".dbtfy-menu_bar");

      menus.length && menus.forEach((menu) => {
        menu.remove();
      });
    }}
  /* end-dbtfy-menu-bar */

  /* start-dbtfy-newsletter-popup */
  function themeNewsletterPopup() {function NewsletterPopup() {
      var dbtfy = $(".dbtfy-newsletter_popup");

      if (!dbtfy.length) {
        return;
      }

      theme.loadScript(theme.variables.jQueryExitIntentPluginLink, initPopup);

      function initPopup() {
        var timeOut = dbtfy.data("timeout"),
          timeTrigger = dbtfy.data("time-trigger"),
          exitIntentTrigger = dbtfy.data("exit-intent"),
          scrollDepthTrigger = dbtfy.data("scroll-depth"),
          pageScrollDepth = dbtfy.data("page-scroll-percentage"),
          formSuccess = $(".np-success")[0],
          applyCoupon = $(".np-apply-coupon"),
          $floatingBar = $(".np-floating-bar"),
          newsletterPopup = $("#NewsletterPopup"),
          newsletterInput = $("#input-newsletter_popup"),
          npDiscount = parseInt(dbtfy.data("discount")),
          npDiscountCode = dbtfy.data("discount-code"),
          npDiscountType = dbtfy.data("discount-type");

        // Autofocus on desktop only
        if (theme.variables.bpSmall) {
          newsletterInput.removeAttr("data-focus");
        } else {
          newsletterInput.attr("data-focus", "");
        }

        function openNewsletterPopup() {
          if (!sessionStorage.newsletterPopupClosed) {
            theme.modal.open(newsletterPopup);
          }
        }

        // Apply discount
        function applyNewsletterDiscount(cart) {
          if (npDiscountCode && npDiscountType && npDiscount) {
            const npDiscountObject = {
              name: npDiscountCode,
              type: npDiscountType,
              amount: npDiscount
            };

            const existedDiscount = sessionStorage.getItem("discount") ? JSON.parse(sessionStorage.getItem("discount")) : null;

            if (existedDiscount) {
              switch (existedDiscount.type) {
                case "%":
                  if (existedDiscount.amount < npDiscount) {
                    sessionStorage.setItem("discount", JSON.stringify(npDiscountObject));
                  }

                  break;

                case "$":
                  const cartTotal = cart.total_price / 100;
                  const existedDiscountInPercents = (existedDiscount.amount * 100) / cartTotal;

                  if (existedDiscountInPercents < npDiscount) {
                    sessionStorage.setItem("discount", JSON.stringify(npDiscountObject));
                  }

                  break;
              }
            } else {
              sessionStorage.setItem("discount", JSON.stringify(npDiscountObject));
            }
          }
        }

        applyCoupon.click(function () {
          ShopifyAPI.getCart(applyNewsletterDiscount);
        });

        $(newsletterPopup).on("modal.close", function() {
          sessionStorage.setItem("newsletterPopupClosed", "true");
        });

        $(window).blur(function(e) {
          if (!$("iframe").is(":focus")) {
            openNewsletterPopup();
          }
        });

        $floatingBar.on("click", function () {
          sessionStorage.removeItem("newsletterPopupClosed");
          openNewsletterPopup();
        });

        if (formSuccess) {
          const applyButton = $(formSuccess).find(".np-reward-apply");

          openNewsletterPopup();

          applyButton.on("click", function() {
            const discountName = formSuccess.dataset.discountName;
            const discountType = formSuccess.dataset.discountType;
            const discountAmount = +formSuccess.dataset.discountAmount;

            if (discountName && discountType && discountAmount) {
              theme.discountCode.addDiscount(discountName, discountType, discountAmount);
              theme.discountCode.init();
            }
          });
        } else {
          // Time based trigger
          if (timeTrigger) {
            setTimeout(function () {
              openNewsletterPopup();
            }, timeOut);
          }

          // Exit-intent trigger
          if (exitIntentTrigger) {
            $.exitIntent("enable");

            $(document).bind("exitintent", function () {
              openNewsletterPopup();
            });
          }

          // Scroll depth trigger
          if (scrollDepthTrigger) {
            var windowHeight = $(window).height(),
              documentHeight = $(document).height();

            $(window).on("scroll", function () {
              var scrollTop = $(window).scrollTop(),
                trackLength = documentHeight - windowHeight,
                percentageScrolled = Math.floor(scrollTop / trackLength * 100),
                pageDepth = parseInt(pageScrollDepth);

              if (percentageScrolled > pageDepth) {
                openNewsletterPopup();
              }
            });
          }
        }
      }
    }

    if (window.location.pathname !== "/challenge") {
      NewsletterPopup();
    }}

  function themeNewsletterPopupDestroy() {document.body.classList.add("dbtfy-newsletter_popup-destroy");

    destroyNewsletterPopup();

    $(document).on("shopify:section:load", function() {
      destroyNewsletterPopup();
    });

    function destroyNewsletterPopup() {
      const newsletterPopups = document.querySelectorAll(".dbtfy-newsletter_popup");

      newsletterPopups.length && newsletterPopups.forEach((newsletterPopup) => {
        newsletterPopup.remove();
      });
    }}
  /* end-dbtfy-newsletter-popup */

  /* start-dbtfy-order-feedback */
  function themeOrderFeedback() {}

  function themeOrderFeedbackDestroy() {}
  /* end-dbtfy-order-feedback */

  /* start-dbtfy-order-tracking */
  function themeOrderTracking() {}

  function themeOrderTrackingDestroy() {}
  /* end-dbtfy-order-tracking */

  /* start-dbtfy-page-transition */
  function themePageTransition() {}

  function themePageTransitionDestroy() {}
  /* end-dbtfy-page-transition */

  /* start-dbtfy-page-speed-booster */
  function themePageSpeedBooster() {function PageSpeedBooster() {
      theme.loadScript(theme.variables.speedBoosterPluginLink);
    }

    PageSpeedBooster();}
  /* end-dbtfy-page-speed-booster */

  /* start-dbtfy-pricing-table */
  function themePricingTableDestroy() {}
  /* end-dbtfy-pricing-table */

  /* start-dbtfy-product-bullet-points */
  function themeProductBulletPoints() {}

  function themeProductBulletPointsDestroy() {}
  /* end-dbtfy-product-bullet-points */

  /* start-dbtfy-product-image-crop */
  function themeProductImageCropDestroy() {}
  /* end-dbtfy-product-image-crop */

  /* start-dbtfy-product-tabs */
  function themeProductTabsDestroy() {}
  /* end-dbtfy-product-tabs */

  /* start-dbtfy-quantity-breaks */
  function themeQuantityBreaks() {}

  function themeQuantityBreaksDestroy() {}
  /* end-dbtfy-quantity-breaks */

  /* start-dbtfy-quick-view */
  function themeQuickView() {}

  function themeQuickViewDestroy() {}
  /* end-dbtfy-quick-view */

  /* start-dbtfy-recently-viewed */
  function themeRecentlyViewed() {function RecentlyViewed() {
      var dbtfy = $(".dbtfy-recently_viewed"),
        rvBox = ".rv-box",
        rvMain = ".rv-main",
        rvGrid = "rv-js-grid",
        rvProductdiv = ".rv-product-js",
        rvThumbnail = $(".rv-js-grid .rv-thumbnail"),
        rvTemplate = "recently-viewed",
        $body = $("body"),
        rvProductHandle,
        rvStorage,
        rvProducts,
        displayProducts,
        rvProductArray;

      if (!dbtfy.length) {
        return;
      }

      // If length of the product Handle
      if ($body.hasClass("template-product") && $(".product-single[data-product-handle]").length) {
        rvProductHandle = $(".product-single").data("product-handle").toString();
        rvStorage = localStorage.getItem("RecentlyViewed");
        rvProducts = getStorageProducts(rvStorage, rvProductHandle);
      } else if (dbtfy.length) {
        rvStorage = localStorage.getItem("RecentlyViewed");
        rvProducts = getStorageProducts(rvStorage, rvProductHandle);
      }

      if (rvProducts) {
        rvProductArray = unescape(rvProducts).split(",");
      }

      if (rvProductHandle) {
        // If current product handle in recently viewed list
        if(!$.inArray(rvProductHandle, rvProductArray) !== -1) {
          displayProducts = [];
          rvProductArray.unshift(rvProductHandle);

          $.each(rvProductArray, function(i, el) {
            if ($.inArray(el, displayProducts) === -1) {
              displayProducts.push(el);
            }
          });
        }

        setStorageProducts(displayProducts);
      } else {
        displayProducts = rvProductArray;
      }

      if (dbtfy.length) {
        getProductInformation(dbtfy, displayProducts, rvProductHandle);
      }

      // Get product handle from the localStorage
      function getStorageProducts(rvStorage, rvProductHandle) {
        if (!rvStorage && rvProductHandle) {
          localStorage.setItem("RecentlyViewed", rvProductHandle);
        }

        rvStorage = localStorage.getItem("RecentlyViewed");

        return rvStorage;
      }

      function setStorageProducts(rvProductArray) {
        localStorage.setItem("RecentlyViewed", escape(rvProductArray.join(",")));
      }

      function getProductInformation(parent, displayProducts, productHandle) {
        if (productHandle) {
          displayProducts.splice($.inArray(productHandle, displayProducts), 1);
        }

        var productLimit = parent.data("visible-products");

        if (productLimit && displayProducts) {
          displayProducts = displayProducts.slice(0, productLimit);
        }

        $.each(displayProducts, function (index, value) {
          if (value) {
            $.ajax({
              type: "GET",
              url: `/products/${value}?view=${rvTemplate}`,
              dataType: "html",
              success: function(data) {
                var rvProduct = $(data).find(rvProductdiv);

                parent.find(`${rvBox}-${index}`).append(rvProduct);
                parent.show();

                document.dispatchEvent(new CustomEvent("dbtfy:addedRecentlyViewedProduct"));
              },
              error: function(x, t, m) {
                console.log(x);
                console.log(t);
                console.log(m);
              }
            });
          }

          if (parent.find(rvMain).hasClass(rvGrid)) {
            if (displayProducts.length <= productLimit) {
              rvThumbnail.eq(displayProducts.length).nextAll().addBack().remove();
            } else {
              rvThumbnail.eq(productLimit).nextAll().addBack().remove();
            }
          }
        });
      }
    }

    RecentlyViewed();}

  function themeRecentlyViewedDestroy() {destroyRecentlyViewed();

    function destroyRecentlyViewed() {
      const recentlyViewedSections = document.querySelectorAll(".dbtfy-recently_viewed");

      recentlyViewedSections.length && recentlyViewedSections.forEach((recentlyView) => {
        recentlyView.remove();
      });
    }}
  /* end-dbtfy-recently-viewed */

  /* start-dbtfy-sales-countdown */
  function themeSalesCountdown() {}

  function themeSalesCountdownDestroy() {}
  /* end-dbtfy-sales-countdown */

  /* start-dbtfy-sales-pop */
  function themeSalesPop() {}

  function themeSalesPopDestroy() {}
  /* end-dbtfy-sales-pop */

  /* start-dbtfy-shop-protect */
  function themeShopProtect() {}
  /* end-dbtfy-shop-protect */

  /* start-dbtfy-size-chart */
  function themeSizeChart() {}

  function themeSizeChartDestroy() {}
  /* end--dbtfy-size-chart */

  /* start-dbtfy-smart-search */
  function themeSmartSearch() {}

  function themeSmartSearchDestroy() {}
  /* end-dbtfy-smart-search */

  /* start-dbtfy-social-discount */
  function themeSocialDiscount() {}

  function themeSocialDiscountDestroy() {}
  /* end-dbtfy-social-discount */

  /* start-dbtfy-sticky-addtocart */
  function themeStickyAddtocart() {}

  function themeStickyAddtocartDestroy() {}
  /* end-dbtfy-sticky-addtocart */

  /* start-dbtfy-synced-variant-image */
  function themeSyncedVariantImage() {}
  /* end-dbtfy-synced-variant-image */

  /* start-dbtfy-trust-badge */
  function themeTrustBadgeDestroy() {destroyTrustBadge();

    function destroyTrustBadge() {
      const trustBadges = document.querySelectorAll(".dbtfy-trust_badge");

      trustBadges.length && trustBadges.forEach((trustBadge) => {
        trustBadge.remove();
      });
    }}
  /* end-dbtfy-trust-badge */

  /* start-dbtfy-upsell-bundles */
  function themeUpsellBundles() {}

  function themeUpsellBundlesDestroy() {}
  /* end-dbtfy-upsell-bundles */

  /* start-dbtfy-upsell-popup */
  function themeUpsellPopup() {}

  function themeUpsellPopupDestroy() {}
  /* end-dbtfy-upsell-popup */

  /* start-dbtfy-wish-list */
  function themeWishList() {function Wishlist() {
      const dbtfy = document.querySelector(".dbtfy-wish_list");

      if (!dbtfy) {
        return;
      }

      const settings = {
        localStorageName: "wishlist",
        activeClass: "wl-active",
        hiddenClass: "hidden",
        submitButtonDefaultClass: "btn-outline-primary",
        submitButtonAddedClass: "btn--primary",
        addButtons: ".wl-add",
        removeButtons: ".wl-remove",
        submitButtons: ".wl-button",
        atcSelects: ".wl-select",
        wlItems: ".wl-item",
        wlCounts: ".wl-count",
        wishlistSocial: document.querySelector(".wl-social-sharing"),
        noItems: document.querySelectorAll(".wl-no-item"),
        bubbleIcons: document.querySelectorAll(".wl-bubble"),
        pageTemplate: document.getElementById("WishlistTemplate")
      };

      init();

      function init() {
        const sections = new theme.Sections();

        sections.register("wish-list-page", initWishListPage);

        initWishlist();

        $("body").on("afterRecommendationLoad", function(evt) {
          initWishlist();
        });
      }

      function initWishlist() {
        initWishlistHeaderBubble();
        initWishlistAddEvent();
        initWishlistRemoveEvent();
      }

      function initWishlistHeaderBubble() {
        const storedWishlist = getStoredWishlist();

        if (!storedWishlist || !storedWishlist.length) {
          // Update wishlist count
          setWishlistCount(0);

          return;
        }

        const filteredWishlist = storedWishlist.filter((handle) => {
          return !!handle;
        });

        filteredWishlist.forEach((productHandle) => {
          const wishlistIconsWithCurrentProduct = document.querySelectorAll(`${settings.addButtons}[data-product-handle="${productHandle}"]`);

          wishlistIconsWithCurrentProduct && wishlistIconsWithCurrentProduct.forEach((wishlistIcon) => {
            let removeWishlistText = wishlistIcon.getAttribute("data-remove-wish-list-text");

            wishlistIcon.classList.add(settings.activeClass);
            wishlistIcon.setAttribute("aria-label", removeWishlistText);
            wishlistIcon.setAttribute("title", removeWishlistText);
          });
        });

        setElementsVisibility(settings.bubbleIcons, true);

        // Update wishlist count
        theme.fetchProductMarkup({
          template: "wish-list",
          productHandles: filteredWishlist
        }, (productMarkups) => {
          const availableProductsCount = Object.entries(productMarkups).reduce((acc, [productHandle, markup]) => {
            if (markup.includes("<!doctype html>")) {
              return acc;
            }

            return acc + 1;
          }, 0);

          setWishlistCount(availableProductsCount);
        });
      }

      function initWishlistAddEvent() {
        const addButtons = document.querySelectorAll(settings.addButtons);

        addButtons && addButtons.length && addButtons.forEach((addButton) => {
          const hasClickEvent = addButton.hasAttribute("data-has-click-event");

          if (!hasClickEvent) {
            addButton.addEventListener("click", () => {
              const productHandle = addButton.dataset.productHandle;
              const isActiveButton = addButton.classList.contains(settings.activeClass);
              const isAddAction = !isActiveButton;
              const addWishlistText = addButton.getAttribute("data-add-wish-list-text");
              const removeWishlistText = addButton.getAttribute("data-remove-wish-list-text");

              if (!productHandle) {
                return;
              }


              if (isActiveButton) {
                addButton.classList.remove(settings.activeClass);
                addButton.setAttribute("aria-label", addWishlistText);
                addButton.setAttribute("title", addWishlistText);
              } else {
                addButton.classList.add(settings.activeClass);
                addButton.setAttribute("aria-label", removeWishlistText);
                addButton.setAttribute("title", removeWishlistText);
              }

              updateWishlist(isAddAction, productHandle);
            });

            addButton.setAttribute("data-has-click-event", "true");
          }
        });
      }

      function initWishlistRemoveEvent() {
        const removeButtons = document.querySelectorAll(settings.removeButtons);

        removeButtons && removeButtons.length && removeButtons.forEach((removeButton) => {
          const hasClickEvent = removeButton.hasAttribute("data-has-click-event");

          if (!hasClickEvent) {
            removeButton.addEventListener("click", (e) => {
              e.preventDefault();

              const productHandle = removeButton.dataset.productHandle;

              if (!productHandle || removeButton.hasAttribute("data-has-remove-event")) {
                return;
              }

              updateWishlist(false, productHandle);
            });

            removeButton.setAttribute("data-has-click-event", "true");
          }
        });
      }

      function initWishListPage() {
        let storedWishlist = getStoredWishlist();

        // If URL contains wishlist products list
        if (window.location.href.indexOf("?wishlist") > -1) {
          const wishlistUrlParams = window.location.href.split('?');
          const wishlistQueryParams = new URLSearchParams(wishlistUrlParams[1]);
          const wishlistProducts = wishlistQueryParams.get("wishlist").split(",");

          wishlistProducts.forEach(function (productHandle) {
            if (!storedWishlist || !storedWishlist.length) {
              storedWishlist = [productHandle];
            } else {
              storedWishlist = storedWishlist.filter((storedProductHandle) => {
                return storedProductHandle !== productHandle;
              });

              storedWishlist.push(productHandle);
            }
          });

          storedWishlist = JSON.stringify(storedWishlist);

          saveWishlistToLocalStorage(storedWishlist);
          initWishlistHeaderBubble();

          storedWishlist = getStoredWishlist();
        }

        if (!storedWishlist || !storedWishlist.length) {
          setElementsVisibility(settings.noItems, true);
          setElementsVisibility([settings.wishlistSocial], false);

          return;
        }

        const filteredWishlist = storedWishlist.filter((productHandle) => {
          return !!productHandle;
        });

        setElementsVisibility(settings.noItems, false);
        setElementsVisibility([settings.wishlistSocial], true);

        theme.fetchProductMarkup({
          template: "wish-list",
          productHandles: filteredWishlist
        }, (productMarkups) => {
          let visibleProductsCount = 0;
          const wishlistMarkup = Object.entries(productMarkups).reduce((acc, [productHandle, markup]) => {
            if (markup.includes("<!doctype html>")) {
              return acc;
            }

            visibleProductsCount++;

            return acc + `<div id="WishlistCard-${productHandle}" class="card fadeInUp"><div class="card-body">${markup}</div></div>`;
          }, "");

          setWishlistCount(visibleProductsCount);

          if (!wishlistMarkup) {
            setElementsVisibility(settings.noItems, true);
            setElementsVisibility([settings.wishlistSocial], false);
            setWishlistCount(0);
          } else {
            settings.pageTemplate.insertAdjacentHTML("afterbegin", wishlistMarkup);

            initWishlistAddEvent();
            initWishlistRemoveEvent();
            initWishlistPageAddtocart();
            initAjaxDrawer();
            themeUpsellPopup();
          }
        });

        // Share wishlist products
        const socialSharingUrl = `${window.location.href}%3Fwishlist=${filteredWishlist}`;
        const facebookIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector(".btn-facebook") : null;
        const twitterIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-twitter') : null;
        const pinterestIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-pinterest') : null;
        const whatsappIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-whatsapp') : null;
        const linkedinIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-linkedin') : null;
        const redditIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-reddit') : null;
        const emailIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-email') : null;
        const messengerIcon = settings.wishlistSocial ? settings.wishlistSocial.querySelector('.btn-messenger') : null;

        if (facebookIcon) {
          let shareContent = facebookIcon.dataset.shareContent;

          facebookIcon.setAttribute('href', `//www.facebook.com/sharer/sharer.php?u=${socialSharingUrl}&quote=${shareContent}`);
        }

        if (twitterIcon) {
          let shareContent = twitterIcon.dataset.shareContent;

          twitterIcon.setAttribute('href', `//twitter.com/intent/tweet?source=${socialSharingUrl}&text=${socialSharingUrl}%20${shareContent}`);
        }

        if (pinterestIcon) {
          let shareContent = pinterestIcon.dataset.shareContent;
          let shareMedia = encodeURIComponent(pinterestIcon.dataset.shareMedia);

          pinterestIcon.setAttribute('href', `//pinterest.com/pin/create/button/?url=${socialSharingUrl}&media=${shareMedia}&description=${shareContent}`);
        }

        if (whatsappIcon) {
          whatsappIcon.setAttribute('href', `//api.whatsapp.com/send?text=${socialSharingUrl}`);
        }

        if (linkedinIcon) {
          let shareTitle = linkedinIcon.dataset.shareTitle;
          let shareDescription = linkedinIcon.dataset.shareDescription;

          linkedinIcon.setAttribute('href', `//www.linkedin.com/shareArticle?mini=true&url=${socialSharingUrl}&title=${shareTitle}&summary=${shareDescription}&source=${socialSharingUrl}`);
        }

        if (redditIcon) {
          let shareContent = redditIcon.dataset.shareContent;

          redditIcon.setAttribute('href', `//www.reddit.com/submit?url=${socialSharingUrl}&title=${shareContent}`);
        }

        if (emailIcon) {
          let shareContent = emailIcon.dataset.shareContent;
          let shareTitle = emailIcon.dataset.shareTitle;

          emailIcon.setAttribute('href', `mailto:?subject=${shareTitle}&body=${socialSharingUrl}%0D%0D${shareContent}%0D`);
        }

        if (messengerIcon) {
          messengerIcon.setAttribute('href', `fb-messenger://share/?link=${socialSharingUrl}&app_id=`);
        }
        // End share wishlist products
      }

      function initWishlistPageAddtocart() {
        const submitButtons = document.querySelectorAll(settings.submitButtons);
        const atcSelects = document.querySelectorAll(settings.atcSelects);

        submitButtons && submitButtons.length && submitButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            theme.loadingState.init(button);

            $("body").on("ajaxCart.afterCartLoad", (evt, cart) => {
              theme.loadingState.destroy(button);
            });
          });
        });

        atcSelects.length && atcSelects.forEach((select) => {
          select.addEventListener("change", (e) => {
            const $body = $("body");
            const submitButton = select.nextElementSibling;

            if (submitButton) {
              setElementsVisibility([select], false);
              setElementsVisibility([submitButton], true);

              submitButton.click();

              window.wishlistAdded = true;

              $body.on("ajaxCart.afterCartLoad", (evt, cart) => {
                if (theme.settings.cartType === "drawer") {
                  timber.RightDrawer.init();
                  timber.RightDrawer.open();
                }

                setElementsVisibility([select], true);
                setElementsVisibility([submitButton], false);

                const isProductInCart = cart.items.some((item) => {
                  return item.id === +select.value;
                });

                if (isProductInCart) {
                  submitButton.classList.remove(settings.submitButtonDefaultClass);
                  submitButton.classList.add(settings.submitButtonAddedClass);

                  select.classList.remove(settings.submitButtonDefaultClass);
                  select.classList.add(settings.submitButtonAddedClass);
                } else {
                  submitButton.classList.add(settings.submitButtonDefaultClass);
                  submitButton.classList.remove(settings.submitButtonAddedClass);

                  select.classList.add(settings.submitButtonDefaultClass);
                  select.classList.remove(settings.submitButtonAddedClass);
                  select.selectedIndex = 0;
                }
              });

              $body.on("ajaxCart.cartAddError", (evt, cart) => {
                setElementsVisibility([select], true);
                setElementsVisibility([submitButton], false);
              });
            }
          });

          /* Convert options select dropdown price */
          var currencySelector = $("#currency-list-header[name='dbtfy-custom-currencies']");

          if (currencySelector.length) {
            Array.from(select.options).forEach((option) => {
              let variantTitle = option.getAttribute("data-variant-title"),
                variantPrice = parseFloat(option.getAttribute("data-variant-price")),
                shopCurrency = theme.strings.shopCurrency;

              if (!isNaN(variantPrice)) {
                var newVariantPrice = Currency.convert(variantPrice, shopCurrency, Currency.currentCurrency),
                  formattedPrice = Currency.formatMoney(newVariantPrice, Currency.moneyFormats[Currency.currentCurrency].money_format);

                option.innerHTML = (`${variantTitle} - ${formattedPrice}`);
              }
            });
          }
        });
      }

      function initAjaxDrawer() {
        if (theme.settings.cartType === "drawer") {
          theme.ajaxCart.init();
        }
      }

      function updateWishlist(isAddAction, productHandle) {
        const wishlistItem = document.getElementById(`WishlistCard-${productHandle}`);

        let wishlist = getStoredWishlist();

        if (isAddAction) {
          if (!wishlist) {
            wishlist = [productHandle];
          } else {
            wishlist.push(productHandle);
          }
        } else {
          wishlistItem && wishlistItem.remove();

          // Get new wishlist without target product
          wishlist = wishlist.filter((storedProductHandle) => {
            return storedProductHandle !== productHandle;
          });
        }

        if (wishlist && wishlist.length) {
          setElementsVisibility(settings.bubbleIcons, true);
          setElementsVisibility(settings.noItems, false);
          setElementsVisibility([settings.wishlistSocial], true);
        } else {
          setElementsVisibility(settings.bubbleIcons, false);
          setElementsVisibility(settings.noItems, true);
          setElementsVisibility([settings.wishlistSocial], false);
        }

        wishlist = JSON.stringify(wishlist);

        saveWishlistToLocalStorage(wishlist);
        initWishlistHeaderBubble();
      }

      function setElementsVisibility(elements, isToShow) {
        elements.length && elements.forEach((elem) => {
          if (elem) {
            elem.style.display = isToShow ? "block" : "none";
          }
        });
      }

      function setWishlistCount(count) {
        const wlCounts = document.querySelectorAll(settings.wlCounts);

        wlCounts.length && wlCounts.forEach((wlCount) => {
          wlCount.innerHTML = count;
        });
      }

      function getStoredWishlist() {
        const storedWishlist = localStorage.getItem(settings.localStorageName);

        return JSON.parse(storedWishlist);
      }

      function saveWishlistToLocalStorage(wishlist) {
        localStorage.setItem(settings.localStorageName, wishlist);
      }
    }

    Wishlist();}

  function themeWishListDestroy() {document.body.classList.add("dbtfy-wish_list-destroy");

    destroyWishlist();

    $("body").on("afterRecommendationLoad", function (evt) {
      destroyWishlist();
    });

    $("body").on("ajaxCart.afterCartLoad", function (evt) {
      destroyWishlist();
    });

    function destroyWishlist() {
      const wishlistIcons = document.querySelectorAll(".dbtfy-wish_list");

      wishlistIcons.length && wishlistIcons.forEach((wishlistIcon) => {
        wishlistIcon.remove();
      });
    }}
  /* end-dbtfy-wish-list */

  document.addEventListener("dbtfy:loaded", function(event) {
    /* start-register */
    var sections = new theme.Sections();

    const addons = {
      "dbtfy_addtocart_animation": {
        "init": () => {
          sections.register("product-template", themeAddtocartAnimation);
        },
        "destroy": () => {}
      },
      "dbtfy_age_check": {
        "init": themeAgeCheck,
        "destroy": themeAgeCheckDestroy
      },
      "dbtfy_agree_to_terms": {
        "init": themeAgreeToTerms,
        "destroy": themeAgreeToTermsDestroy
      },
      "dbtfy_automatic_geolocation": {
        "init": themeAutomaticGeolocation,
        "destroy": () => {}
      },
      "dbtfy_back_in_stock": {
        "init": themeBackInStock,
        "destroy": themeBackInStockDestroy
      },
      "dbtfy_cart_countdown": {
        "init": themeCartCountdown,
        "destroy": themeCartCountdownDestroy
      },
      "dbtfy_cart_discount": {
        "init": themeCartDiscount,
        "destroy": themeCartDiscountDestroy
      },
      "dbtfy_cart_favicon": {
        "init": themeCartFavicon,
        "destroy": () => {}
      },
      "dbtfy_cart_goal": {
        "init": themeCartGoal,
        "destroy": themeCartGoalDestroy
      },
      "dbtfy_cart_savings": {
        "init": themeCartSavings,
        "destroy": themeCartSavingsDestroy
      },
      "dbtfy_cart_upsell": {
        "init": themeCartUpsell,
        "destroy": themeCartUpsellDestroy
      },
      "dbtfy_collection_addtocart": {
        "init": themeCollectionAddtocart,
        "destroy": themeCollectionAddtocartDestroy
      },
      "dbtfy_collection_filters": {
        "init": themeCollectionFilters,
        "destroy": themeCollectionFiltersDestroy
      },
      "dbtfy_color_swatches": {
        "init": themeColorSwatches,
        "destroy": themeColorSwatchesDestroy
      },
      "dbtfy_cookie_box": {
        "init": themeCookieBox,
        "destroy": themeCookieBoxDestroy
      },
      "dbtfy_custom_currencies": {
        "init": themeCustomCurrencies,
        "destroy": themeCustomCurrenciesDestroy
      },
      "dbtfy_delivery_time": {
        "init": () => {},
        "destroy": themeDeliveryTimeDestroy
      },
      "dbtfy_discount_saved": {
        "init": themeDiscountSaved,
        "destroy": themeDiscountSavedDestroy
      },
      "dbtfy_faq_page": {
        "init": () => {
          sections.register("faq-page", themeFaqPage);
        },
        "destroy": themeFaqPageDestroy
      },
      "dbtfy_facebook_messenger": {
        "init": () => {},
        "destroy": themeFacebookMessengerDestroy
      },
      "dbtfy_inactive_tab_message": {
        "init": themeInactiveTabMessage,
        "destroy": () => {}
      },
      "dbtfy_infinite_scroll": {
        "init": themeInfiniteScroll,
        "destroy": themeInfiniteScrollDestroy
      },
      "dbtfy_instagram_feed": {
        "init": () => {
          sections.register("instagram-feed", themeInstagramFeed);
        },
        "destroy": themeInstagramFeedDestroy
      },
      "dbtfy_inventory_quantity": {
        "init": themeInventoryQuantity,
        "destroy": themeInventoryQuantityDestroy
      },
      "dbtfy_linked_options": {
        "init": themeLinkedOptions,
        "destroy": () => {}
      },
      "dbtfy_live_view": {
        "init": () => {
          sections.register("product-template", themeLiveView);
        },
        "destroy": themeLiveViewDestroy
      },
      "dbtfy_mega_menu": {
        "init": () => {
          sections.register("header-section", themeMegaMenu);
        },
        "destroy": themeMegaMenuDestroy
      },
      "dbtfy_menu_bar": {
        "init": () => {},
        "destroy": themeMenuBarDestroy
      },
      "dbtfy_newsletter_popup": {
        "init": themeNewsletterPopup,
        "destroy": themeNewsletterPopupDestroy
      },
      "dbtfy_order_feedback": {
        "init": themeOrderFeedback,
        "destroy": themeOrderFeedbackDestroy
      },
      "dbtfy_order_tracking": {
        "init": themeOrderTracking,
        "destroy": themeOrderTrackingDestroy
      },
      "dbtfy_page_speed_booster": {
        "init": themePageSpeedBooster,
        "destroy": () => {}
      },
      "dbtfy_page_transition": {
        "init": themePageTransition,
        "destroy": themePageTransitionDestroy
      },
      "dbtfy_pricing_table": {
        "init": () => {},
        "destroy": themePricingTableDestroy
      },
      "dbtfy_product_bullet_points": {
        "init": themeProductBulletPoints,
        "destroy": themeProductBulletPointsDestroy
      },
      "dbtfy_product_image_crop": {
        "init": () => {},
        "destroy": themeProductImageCropDestroy
      },
      "dbtfy_product_tabs": {
        "init": () => {},
        "destroy": themeProductTabsDestroy
      },
      "dbtfy_quantity_breaks": {
        "init": themeQuantityBreaks,
        "destroy": themeQuantityBreaksDestroy
      },
      "dbtfy_quick_view": {
        "init": themeQuickView,
        "destroy": themeQuickViewDestroy
      },
      "dbtfy_recently_viewed": {
        "init": themeRecentlyViewed,
        "destroy": themeRecentlyViewedDestroy
      },
      "dbtfy_sales_countdown": {
        "init": themeSalesCountdown,
        "destroy": themeSalesCountdownDestroy
      },
      "dbtfy_sales_pop": {
        "init": themeSalesPop,
        "destroy": themeSalesPopDestroy
      },
      "dbtfy_shop_protect": {
        "init": themeShopProtect,
        "destroy": () => {}
      },
      "dbtfy_size_chart": {
        "init": () => {
          sections.register("product-template", themeSizeChart);
        },
        "destroy": themeSizeChartDestroy
      },
      "dbtfy_smart_search": {
        "init": themeSmartSearch,
        "destroy": themeSmartSearchDestroy
      },
      "dbtfy_social_discount": {
        "init": () => {
          sections.register("product-template", themeSocialDiscount);
        },
        "destroy": themeSocialDiscountDestroy
      },
      "dbtfy_sticky_addtocart": {
        "init": () => {
          sections.register("product-template", themeStickyAddtocart);
        },
        "destroy": themeStickyAddtocartDestroy
      },
      "dbtfy_synced_variant_image": {
        "init": themeSyncedVariantImage,
        "destroy": () => {}
      },
      "dbtfy_trust_badge": {
        "init": () => {},
        "destroy": themeTrustBadgeDestroy
      },
      "dbtfy_upsell_bundles": {
        "init": () => {
          sections.register("bundle-recommendations", themeUpsellBundles);
        },
        "destroy": themeUpsellBundlesDestroy
      },
      "dbtfy_upsell_popup": {
        "init": () => {
          sections.register("upsell-popup", themeUpsellPopup);
        },
        "destroy": themeUpsellPopupDestroy
      },
      "dbtfy_wish_list": {
        "init": themeWishList,
        "destroy": themeWishListDestroy
      }
    };

    const enabledAddons = event.detail.enabledAddons;

    for (const [addonName, addonInfo] of Object.entries(addons)) {
      const isEnabledAddon = enabledAddons.some((enabledAddon) => {
        return enabledAddon.name === addonName;
      });

      if (isEnabledAddon) {
        addonInfo.init();
      } else {
        addonInfo.destroy();
      }
    }
    /* end-register */
  });
})();
